import {select} from "../../store";
import {ADMISSION_WELCOME_ROUTE} from "../../pages/page-admission-welcome/route";
import {createRouteGuard} from "../../routers/createRouteGuard";

export const UserHasAdmissionToken = createRouteGuard({
  authenticatedSelector: select.admissionSession.hasAdmissionToken,
  redirectPath: ADMISSION_WELCOME_ROUTE,
});
